module.exports = __webpack_public_path__ + "static/media/default-bg-image.9645a1dd.png";